import { render, staticRenderFns } from "./MediaSelector.vue?vue&type=template&id=189890ac&scoped=true"
import script from "./MediaSelector.vue?vue&type=script&lang=js"
export * from "./MediaSelector.vue?vue&type=script&lang=js"
import style0 from "./MediaSelector.vue?vue&type=style&index=0&id=189890ac&prod&scoped=true&lang=css"
import style1 from "./MediaSelector.vue?vue&type=style&index=1&id=189890ac&prod&lang=scss"
import style2 from "./MediaSelector.vue?vue&type=style&index=2&id=189890ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../filemanager/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189890ac",
  null
  
)

export default component.exports